module.exports = __webpack_public_path__ + "img/p28.23802696.png";